import Fuse from 'fuse.js';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { MultiSelect } from '~/components';
import { sortAlphabetically } from '~/utils';
import { events } from '../lookups';

const options = sortAlphabetically(_.values(events), 'name');

export default function HistoryEventFilter({
  materialPlaceholder = 'Event',
  placeholder = 'All',
  name,
  value,
  onChange,
}) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredOptions = useMemo(() => {
    if (!searchQuery) return options;
    return new Fuse(options, { keys: ['name'], threshold: 0.4 }).search(searchQuery).map(({ item }) => item);
  }, [searchQuery]);

  return (
    <MultiSelect.Filter
      materialAlwaysVisible
      materialPlaceholder={materialPlaceholder}
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={filteredOptions}
      onSearch={setSearchQuery}
      onChange={onChange}
    />
  );
}
